/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
    var tabContents = document.querySelectorAll(".content .tab_content");
    
    // Hide all tab contents initially
    tabContents.forEach(function(content) {
        content.style.display = "none";
    });
    
    // Optionally, you can set the first tab to be active if you want
    var firstTabContent = document.querySelector(".content .tab_content:first-child");
    // If you want to show the first tab content, uncomment the line below
    // firstTabContent.style.display = "block";

    var tabListItems = document.querySelectorAll("ul li");
    tabListItems.forEach(function(item) {
        item.addEventListener("click", function() {
            tabListItems.forEach(function(li) {
                li.classList.remove("active-chart");
            });
            this.classList.add("active-chart");

            var currentTabValue = this.getAttribute("data-list");
            tabContents.forEach(function(content) {
                content.style.display = "none"; // Hide all contents
            });
            document.querySelector("." + currentTabValue).style.display = "block"; // Show the current tab content
        });
    });
});














// Size Chart Fit Guide
document.addEventListener("DOMContentLoaded", function() {

  function runTabSection() {
    const tabs = document.querySelectorAll('.dot-tab');
    const codes = document.querySelectorAll('.dot-tab-content');

    // Hide all contents
    codes.forEach(code => {
      code.style.display = 'none';
    });

    // Show the toggled content
    document.querySelector('.dot-tab-content.toggled').style.display = 'block';

    // Add click event listener to all tabs
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const tabID = this.getAttribute('data-count');

        // Remove active-tab from the previously active tab
        document.querySelector('.dot-tabs .active-tab').classList.remove('active-tab');

        // Add active-tab to the clicked tab
        this.classList.add('active-tab');

        // Fade out the currently displayed content
        const currentContent = document.querySelector('.dot-tabs-content-wrap .dot-tab-content.toggled');
        currentContent.classList.remove('toggled');
        currentContent.style.opacity = 1;

        const fadeOut = setInterval(function() {
          if (currentContent.style.opacity > 0) {
            currentContent.style.opacity -= 0.1;
          } else {
            clearInterval(fadeOut);
            currentContent.style.display = 'none';

            // Fade in the new content
            const newContent = document.querySelector(`.dot-tabs-content-wrap .dot-tab-content[data-count="${tabID}"]`);
            newContent.style.display = 'block';
            newContent.classList.add('toggled');
            newContent.style.opacity = 0;

            const fadeIn = setInterval(function() {
              if (newContent.style.opacity < 1) {
                newContent.style.opacity = parseFloat(newContent.style.opacity) + 0.1;
              } else {
                clearInterval(fadeIn);
              }
            }, 50);
          }
        }, 50);
      });
    });
  }

  runTabSection();
});



// Ibastom Ibastom Ibastom Ibastom Ibastom
// Ibastom Ibastom Ibastom Ibastom Ibastom
// Ibastom Ibastom Ibastom Ibastom Ibastom


// Ibastom Ibastom Ibastom Ibastom Ibastom
// Ibastom Ibastom Ibastom Ibastom Ibastom
// Ibastom Ibastom Ibastom Ibastom Ibastom


